import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { SettingsComponent } from './settings.component';
import { SystemSettingsComponent } from './system-settings.component';
import { ToastModule } from 'primeng';
import { HangfireSettingsComponent } from './hangfire-settings.component';
import { HangfireJobDialogComponent } from './hangfire-job-dialog.component';
import { HangfireEcsManagerComponent } from './hangfire-ecs-manager.component';

const routes: Routes = [
  { path: '', component: SettingsComponent, data: { title: 'System Configuration' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}

@NgModule({
  imports: [
    SettingsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [
    SettingsComponent,
    SystemSettingsComponent,
    HangfireSettingsComponent,
    HangfireJobDialogComponent,
    HangfireEcsManagerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule {}
